import * as yup from 'yup';

const nullableDateField = yup
  .date()
  .nullable()
  .transform((value, originalValue) => {
    if (originalValue === '' || originalValue === null || originalValue === undefined) {
      return null;
    }

    return value;
  });

function createOptionalServiceNumberField(options: { regex: RegExp; lengthMessage: string }) {
  const { regex, lengthMessage } = options;

  return yup.string().test('optional-service-number', function (value) {
    const { serviceNumber1, serviceNumber2, serviceNumber3 } = this.parent as {
      serviceNumber1?: string;
      serviceNumber2?: string;
      serviceNumber3?: string;
    };
    const hasAnyValue = !!serviceNumber1 || !!serviceNumber2 || !!serviceNumber3;

    if (!hasAnyValue && !value) {
      return true;
    }

    if (!value) {
      return this.createError({ message: '전화번호를 입력해주세요.' });
    }

    if (!regex.test(value)) {
      return this.createError({ message: lengthMessage });
    }

    return true;
  });
}

export const modemRegisterSchema = yup.object({
  modem: yup.string().required('모뎀/라우터를 선택하세요.'),
  modemNo: yup.string().when('modem', {
    is: (modem: string) => modem !== 'NONE',
    then: (schema) => schema.required('단말기 일련번호를 입력하세요.'),
    otherwise: (schema) => schema,
  }),
  modemImei: yup.string(),
  statusYn: yup.string().required('모뎀 상태를 선택하세요.'),
  telecom: yup.string(),
  plan: yup.string(),
  usimNo: yup.string(),
  serviceNumber1: createOptionalServiceNumberField({
    regex: /^[0-9]{2,3}$/,
    lengthMessage: '전화번호 형식을 확인해주세요.',
  }),
  serviceNumber2: createOptionalServiceNumberField({
    regex: /^[0-9]{3,4}$/,
    lengthMessage: '전화번호 형식을 확인해주세요.',
  }),
  serviceNumber3: createOptionalServiceNumberField({
    regex: /^[0-9]{4}$/,
    lengthMessage: '전화번호 형식을 확인해주세요.',
  }),
  serviceNo: yup.string(),
  activateStatusYn: yup.string(),
  contractPeriod: yup.string(),
  activateStartDt: nullableDateField,
  activateEndDt: nullableDateField.test('activate-period-order', '개통 해지일은 개통일 이후여야 합니다.', function (value) {
    const { activateStartDt } = this.parent as { activateStartDt?: Date | null };

    if (!activateStartDt || !value) return true;

    return value >= activateStartDt;
  }),
  memo: yup.string(),
});
